import Footer from '../footer/Footer';
import styles from './FestTermsPage.module.scss';
import React from 'react';

const FestTermsPage = () => {
  return (
    <>
      <div className={`${styles.container}`}>
        <div className={`${styles.header}`}>
          <div className={`${styles.headerLogo}`}>
            <a href="/" className="cursor-pointer">
              <img alt="Arre Logo" src={'/assets/logos/arreLogo.svg'} width={'100%'} height={'100%'} />
            </a>
          </div>
        </div>
        <div className={`${styles.contentWrapper}`}>
          <div className={`${styles.welcomeContainer}`}>
            <div className={`${styles.welcomeMsg}`}>Terms and conditions for daily challenge participants</div>
            <div className={`${styles.welcomeIllustration}`} />
          </div>
        </div>
        <div className={`${styles.contentContainer}`}>
          <div className={`${styles.text1}`}>
            These terms and conditions outline the rules and eligibility criteria for participation in our Daily
            Challenge. By participating in the Daily Challenge, you agree to abide by these Terms.
          </div>
          <ol style={{ listStyleType: 'number' }} className={`${styles.pointsContainer}`}>
            <li className={`${styles.pointTitle}`}>
              Eligibility:
              <ol style={{ listStyleType: 'initial' }} className={`${styles.subPoint}`}>
                <li>Creators and Users must be above 18 years of age to be eligible for rewards.</li>
                <li>Participants must be residents of India.</li>
              </ol>
            </li>
            <li className={`${styles.pointTitle}`}>
              Use of HASHTAG:
              <ol style={{ listStyleType: 'initial' }} className={`${styles.subPoint}`}>
                <li>
                  Every creator/user must use the designated HASHTAG for the Weekly Challenge in their content to
                  qualify for inclusion in the challenge playlist.
                </li>
              </ol>
            </li>
            <li className={`${styles.pointTitle}`}>
              Participation Requirement:
              <ol style={{ listStyleType: 'initial' }} className={`${styles.subPoint}`}>
                <li>
                  To qualify for winning rewards, every creator/user must actively participate in all three days of the
                  Weekly Challenge.
                </li>
              </ol>
            </li>
            <li className={`${styles.pointTitle}`}>
              Jury Evaluation & Voice Pods Quality:
              <ol style={{ listStyleType: 'initial' }} className={`${styles.subPoint}`}>
                <li>
                  All voice pod submissions for the Weekly Challenges will be evaluated by an external jury assessing
                  both the content and the quality of voice pods.
                </li>
              </ol>
            </li>
            <li className={`${styles.pointTitle}`}>
              Minimum Engagement Metrics:
              <ol style={{ listStyleType: 'initial' }} className={`${styles.subPoint}`}>
                <li>Creators/users must meet the following minimum engagement metrics to qualify for rewards:</li>
                <ol style={{ listStyleType: 'initial' }} className={`${styles.subPoint}`}>
                  <li>Playcount: 10 plays or more</li>
                  <li>Likes: 5 likes or more</li>
                  <li>Comments: 3 comments or more</li>
                  <li>Share: 2 shares or more</li>
                </ol>
              </ol>
            </li>
            <li className={`${styles.pointTitle}`}>
              Grand Prize Opportunity:
              <ol style={{ listStyleType: 'initial' }} className={`${styles.subPoint}`}>
                <li>
                  Creators who actively participate in all four weekly challenges throughout the month of October will
                  stand a chance to win ONE grand prize.
                </li>
              </ol>
            </li>
          </ol>
          <ol className={`${styles.pointsContainer} ${styles.genPointsContainer}`}>
            <li className={`${styles.pointTitle} ${styles.genPointTitle}`}>
              General Terms
              <ol style={{ listStyleType: 'initial' }} className={`${styles.subPoint} ${styles.genSubPoint}`}>
                <li>Participation in the Weekly Challenge is subject to these Terms.</li>
                <li>
                  Non-compliance with these Terms may result in disqualification from the Weekly Challenge and
                  forfeiture of rewards.
                </li>
                <li>
                  We reserve the right to modify, suspend, or cancel the Weekly Challenge or these Terms at any time
                  without prior notice.
                </li>
                <li>
                  Our decision regarding eligibility, winners, and all other matters pertaining to the Weekly Challenge
                  is final and binding.
                </li>
                <li>
                  By participating in the Weekly Challenge, you consent to the use of your content and name for
                  promotional purposes by the organizers.
                </li>
              </ol>
            </li>
          </ol>
          <div className={`${styles.text2}`}>
            Please review these Terms carefully before participating in the Weekly Challenge. Your participation in the
            Weekly Challenge implies your acceptance of these Terms.
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default FestTermsPage;
